import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UserOrderContext } from 'context/context';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import ImageComponent from 'atoms/Image/index';
import { Row, Col } from 'reactstrap';
import { InputBox } from 'atoms/InputBox';
import { Link, scroller } from 'react-scroll';
import MenuItemList from './MenuItemList';
import MenuSubCategoryItemList from './MenuSubCategoryItemList';
import { ReactSVG } from 'react-svg';
import {
  menuNavigationAnalyticsData,
  getAnalytictsPayloadConditionaly,
  vieItemListAnalytics,
  getCategory,
  setAnalyticsData,
  filterRecommendations,
  getCategoryFromSubCategory,
  menusPlpItemAnalyticFn,
  OnSerchElmnt,
} from '../MenusPlpUtilities/MenusPlpUtils';
import {
  BACK_TO_MENU,
  CLEAR_ALL,
  CLEAR_SEARCH,
  MENU_PLP_CONSTANT,
  TURNED_NO_RESULTS_TEXT,
  WE_FOUND_TEXT,
  YOUR_SEARCH_TEXT,
  RESULTS,
  CATEGORY_ID,
} from '../MenuPLPConstants/MenuPLPConstants';
import {
  notHiddenProductsCount,
  filterNotHiddenItem,
  isEmptyEvery,
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  getAndCheck,
  getEmptyObjectforNull,
} from 'common/utilities/utils';
import MENUS_PLP_CONSTANTS from '../Constants/MenusPLPConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const {
  SearchIcon,
  SearchIconGrey,
  DarkCloseButton,
  StripsIcon,
  Product_Card_Icon,
  ribbonRedOutlined,
  TimerIcon,
  CartError,
} = IMAGE_PATH;

export const getFilterNothiddenitemWithProduct = menulist => {
  const { menu, handleSetActive, setFirstCategoryActive, hasSubcategory, getMenusSubcategory } = menulist;
  return menu.map(({ id, isHidden, name, url, dname, categories: subcategory = [] }, index, item) => {
    return (
      !isHidden &&
      item[index].products.length > 0 && (
        <li key={id}>
          <Link
            data-testid='category-click-test'
            to={name.trim()}
            spy={true}
            smooth={true}
            onSetActive={handleSetActive}
            onClick={e => setFirstCategoryActive(e, index, name.trim(), url)}
            className={`${hasSubcategory(subcategory) ? 'caret' : ''}`}
            offset={-100}
          >
            {dname[0].value}
          </Link>
          {getMenusSubcategory(subcategory || [])}
        </li>
      )
    );
  });
};

export const getRibben = (discount, exclusive, ribbonRedOutlinedVal) => {
  return discount || exclusive ? ribbonRedOutlinedVal : '';
};

export const getSpecial = (specials, discount, exclusive) => {
  if (specials) {
    return specials;
  } else if (discount) {
    return discount;
  } else if (exclusive) {
    return exclusive;
  } else {
    return null;
  }
};

export const GetRibbenClass = exclusive => {
  return exclusive ? 'exclusive-product-ribbon' : 'discount-product-ribbon';
};

export const categoriesMenu = (categoriesList, renderItemList) => {
  return categoriesList
    .filter(({ isHidden }) => !isHidden)
    .map(
      (
        {
          id,
          name,
          dname,
          imageName,
          products,
          categories,
          isHidden,
          displayOrder,
          specials,
          exclusive,
          timer,
          discount,
        },
        index,
      ) => {
        return (
          !isHidden &&
          products.length > 0 && (
            <div
              id={name.trim()}
              className={index === 0 ? 'large-menu-container' : 'medium-menu-container'}
              key={index}
            >
              <div className={index === 0 ? 'large-category-name' : 'medium-category-name'}>
                <h2>{dname[0].value}</h2>
              </div>

              <ReactSVG
                src={specials ? Product_Card_Icon : getRibben(discount, exclusive, ribbonRedOutlined)}
                className={specials ? 'specials-product-ribbon' : GetRibbenClass(exclusive)}
              />
              <span className={specials ? 'specials-ribbon-text' : 'discount-ribbon-text'}>
                {timer ? (
                  <div>
                    <ReactSVG src={TimerIcon} className='product-timer' />
                    <span className='product-timer-text'>timer</span>
                  </div>
                ) : (
                  getSpecial(specials, discount, exclusive)
                )}
              </span>
              {index === 0
                ? renderItemList(products, categories, id, 'large')
                : renderItemList(products, categories, id, 'medium')}
            </div>
          )
        );
      },
    );
};

export const MenusPlpItem = ({
  data,
  tenantData,
  filterList,
  dietaryList,
  sortByList,
  handleClearItems,
  handleFilteredData,
  handleSearchdata,
  tempData,
  recommendations,
  catalogs,
  selectedCat,
  storeClosedData,
  triggerGetRecommends,
  setShowTopScrollBtn,
}) => {
  let { menu, categories, products } = {};
  if (Object.keys(tempData).length) {
    ({ menu, categories, products } = getEmptyObjectforNull(tempData));
  } else {
    ({ menu, categories, products } = getEmptyObjectforNull(data));
  }
  const visibleHiddenProductsCount = notHiddenProductsCount(products);

  const CustomStyledCol = useStyleScripts(STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_DESKTOP, Col);

  const { userOrderState } = useContext(UserOrderContext);
  const history = useHistory();
  const [recommendProducts, setReccomendedProducts] = useState([]);
  const [categoryStatus, setCategoryStatus] = useState(false);
  const [paramValue, setParamValue] = useState(false);
  const [activeMenuSelection, setActiveMenuSelection] = useState('');
  const [menuGtmEventTriggered, setmenuGtmEventTriggered] = useState('');
  const [inputSearchOpen, setInputSearchOpen] = useState(false);
  const [suggestedData, setsuggestedData] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [searchMode, setSearchMode] = useState({ isSearchedMode: false, searchedData: '' });
  const filterRef = useRef(null);
  const tenantReducer = useSelector(state => state.tenantReducer);
  const userStatus = useSelector(state => state.appStateReducer);
  const { SEARCHOURMENU } = MENUS_PLP_CONSTANTS;
  const { category_name } = useParams();

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const params = useMemo(() => {
    return {
      tenantReducer: tenantReducer ?? JSON.parse(localStorage.getItem('tenantReducer')),
      storeInfo: dispositionNew?.store ?? {},
      dispositionType: getDispositionTypeOnAPIFormat(
        dispositionNew?.type || tenantReducer?.authoredContent?.defaultdisposition,
      ),
    };
  }, [dispositionNew, tenantReducer]);

  const { dispositionType } = params;

  const handleClose = () => {
    setCategoryStatus(false);
    history.push({
      pathname: '/menu',
    });
  };
  const handleClickOutside = event => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setInputSearchOpen(false);
    }
  };

  useEffect(() => {
    if (data?.products?.length && searchMode.isSearchedMode && recommendations?.length) {
      let recommentProdArr = filterRecommendations(data?.products, recommendations);
      setReccomendedProducts(recommentProdArr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchMode.searchedData, recommendations]);

  useEffect(() => {
    if (searchMode.searchedData) {
      triggerGetRecommends(searchMode.searchedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchMode.searchedData]);

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  useEffect(() => {
    getCategory(categories, category_name, setParamValue, setCategoryStatus);
    // eslint-disable-next-line
  }, [JSON.stringify(data)]);

  const setFirstCategoryActive = (e, index, categoryName, url) => {
    if (index === 0) {
      let filteredCategories = filterNotHiddenItem(categories);
      filteredCategories.length &&
        scroller.scrollTo(filteredCategories[0].name.trim(), {
          duration: 1500,
          delay: 100,
          smooth: true,
          containerId: '',
          offset: -100,
        });
    }
    menuNavigationAnalyticsData(categoryName, 0);
    setActiveMenuSelection(() => categoryName);
    if (window?.history?.replaceState) {
      window.history.replaceState('', categoryName, `/menu/${url}`);
    } else {
      history.push({
        pathname: `/menu/${url}`,
      });
    }
  };

  const handleSetActive = param => {
    setActiveMenuSelection(() => param);
  };

  useEffect(() => {
    let onScrollEvent = setTimeout(() => {
      if (menuGtmEventTriggered !== activeMenuSelection) {
        const { selectedCategory, selectedSubcategory } = getCategoryFromSubCategory(menu, activeMenuSelection);
        let productList = getAnalytictsPayloadConditionaly(
          selectedCategory,
          selectedSubcategory,
          selectedCategory?.name,
          selectedCategory?.id,
          tenantData?.currencyConversionFactor,
        );
        vieItemListAnalytics(productList);
        setmenuGtmEventTriggered(() => activeMenuSelection);
      }
    }, 300);
    return () => {
      clearTimeout(onScrollEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuSelection]);

  const filteredData = item => {
    // analytics event triggered
    setAnalyticsData(
      {
        eventType: 'suggestedSearchClick',
        selectedData: item.name,
      },
      'suggestedSearchTerm',
    );
    handleFilteredData(item.mdmId);
    setInputSearchOpen(false);
    setInputSearchValue(item.name);
    setSearchMode({ isSearchedMode: true, searchedData: item.name });
  };

  const handleInput = e => {
    setInputSearchValue(e.target.value);
    if (filterList.length || dietaryList.length || sortByList.length) {
      handleClearItems();
    }
    if (e.target.value.toString().length > 2) {
      if (!inputSearchOpen) {
        setInputSearchOpen(true);
        filteredMenu(e.target.value.toString());
      }
    } else {
      if (inputSearchOpen) {
        setInputSearchOpen(false);
        filteredMenu('');
        handleSearchdata();
        setSearchMode({ isSearchedMode: false, searchedData: '' });
      }
    }
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      if (event.target.value === '') {
        return;
      }
      setInputSearchOpen(false);
      handleSearchdata(event.target.value.toLowerCase().toString());
      setSearchMode({ isSearchedMode: true, searchedData: inputSearchValue });
      menusPlpItemAnalyticFn(suggestedData, inputSearchValue);
    }
  };

  const filteredMenu = val => {
    const { products: productsData } = data || {};
    if (productsData) {
      setsuggestedData(
        products
          .filter(obj => !obj.isHidden && obj.name.toLowerCase().indexOf(val.toLowerCase().toString()) !== -1)
          .slice(0, 5),
      );
    }
  };

  const clearSearch = () => {
    setInputSearchValue('');
    setInputSearchOpen(false);
    filteredMenu('');
    handleSearchdata();
    setSearchMode({ isSearchedMode: false, searchedData: '' });
  };

  function onItemClick(event, subCategoryName, url, index) {
    menuNavigationAnalyticsData(subCategoryName, index + 1);
    setActiveMenuSelection(() => subCategoryName);
    const element = event?.target.parentElement.querySelector('.nested');
    if (element) {
      element.classList.toggle('active-tree');
      if (event.target.classList) {
        event.target.classList.toggle('caret-down');
      }
    }
    history.push({
      pathname: `/menu/${url}`,
    });
  }

  const hasSubcategory = (subcategory = []) => {
    return subcategory.length > 0;
  };

  const getMenusSubcategory = category => {
    return category?.map(({ id = '', isHidden = false, dname = '', url, categories: subcategory = [] }, index) => {
      return (
        <ul className='inner-ul nested'>
          {!isHidden && (
            <li>
              <Link
                data-testid='subcategory-click-test'
                className={`${hasSubcategory(subcategory) ? 'caret' : ''}`}
                onClick={e => onItemClick(e, dname[0].value, url, index)}
                to={id}
                spy={true}
                smooth={true}
                onSetActive={handleSetActive}
                activeClass={`${index === 0 ? 'active' : ''}`}
              >
                {dname[0].value}
              </Link>
              {subcategory && subcategory.length > 0 && getMenusSubcategory(subcategory)}
            </li>
          )}
        </ul>
      );
    });
  };

  const getClassName = dataList => {
    if (dataList.find(item => item.toLowerCase() === 'all')) {
      return 'all-data-found-plp';
    }
    return 'data-found-plp';
  };

  const searchModeElmnt = () => {
    return (
      <>
        <div className='no-search-found-plp'>
          <span>{translateWithI18Next(YOUR_SEARCH_TEXT)}</span>
          <span className='no-search-found-text-highlighted'>{` '${searchMode.searchedData}' `}</span>
          <p>{translateWithI18Next(TURNED_NO_RESULTS_TEXT)}</p>
          <ButtonComp onClick={clearSearch} className='back-to-menu-plpsearch'>
            {translateWithI18Next(BACK_TO_MENU)}
          </ButtonComp>
        </div>
        <div className='horizontalLineBorder-noData'></div>
        {!!recommendProducts.length && (
          <div className='mob-plp-sections  mb-5'>
            <div className='mob-plp-col mb-4'>
              <div className='recommended-menu-container medium-menu-container'>
                <div className='d-flex position-relative'>
                  <div className='carousal-header'>{translateWithI18Next(MENU_PLP_CONSTANT.CAROUSAL_HEADER)}</div>
                </div>
                <MenuItemList
                  productList={recommendProducts}
                  cardType='medium'
                  tenantData={tenantData}
                  categoryId={'CAT86'}
                  catalogs={catalogs}
                  storeClosedData={storeClosedData}
                  setShowTopScrollBtn={setShowTopScrollBtn}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderItemList = (productsList, subcategoriesList, cardId, cType) => {
    return subcategoriesList && subcategoriesList.length ? (
      <MenuSubCategoryItemList
        subCategory={subcategoriesList}
        cardType={cType}
        tenantData={tenantData}
        catalogs={catalogs}
        storeClosedData={storeClosedData}
      />
    ) : (
      <MenuItemList
        productList={productsList}
        cardType={cType}
        tenantData={tenantData}
        categoryId={cardId}
        catalogs={catalogs}
        selectedCat={selectedCat}
        storeClosedData={storeClosedData}
        setShowTopScrollBtn={setShowTopScrollBtn}
      />
    );
  };

  return (
    <React.Fragment>
      {displaySectionWhenThereAreNoMatchingProduct(
        paramValue,
        dispositionNew,
        dispositionType,
        categoryStatus,
        storeClosedData,
        handleClose,
      )}
      <Row className='plp-menu-row' data-testid='menus-container'>
        {/* <Col md='3' className='plp-left-nav'> */}
        {CustomStyledCol && (
          <CustomStyledCol md='3' className={localizedClass(userStatus?.localized)}>
            <Row className={`plp-stripes-section plp-stripes-section-in`}>
              <ImageComponent srcFile={StripsIcon} className='stripes-img' />
            </Row>
            <h1 className={`kfc-menu-title kfc-menu-title-in`}>
              {[...filterList, ...dietaryList].length || searchMode.isSearchedMode
                ? `${visibleHiddenProductsCount} Results`
                : translateWithI18Next(MENU_PLP_CONSTANT.NAV_TITLE)}
            </h1>
            {[...filterList, ...dietaryList, ...sortByList].length > 0 || searchMode.isSearchedMode ? (
              <div>
                {visibleHiddenProductsCount >= 0 && (
                  <ButtonComp
                    className='clearAllFilterButton'
                    data-testid='clear-all-handle'
                    onClickHandler={(searchMode.isSearchedMode && clearSearch) || handleClearItems}
                  >
                    {(searchMode.isSearchedMode && translateWithI18Next(CLEAR_SEARCH)) ||
                      translateWithI18Next(CLEAR_ALL)}
                  </ButtonComp>
                )}
                {[...filterList, ...dietaryList, ...sortByList].map((item, index) => (
                  <div className='' key={index}>
                    <div className='selectedFilterButtons'>
                      <span className='textFiltered'>{item}</span>
                      <img
                        className='mlcross'
                        data-testid={`clear-single-handle-${item}`}
                        onClick={() => handleClearItems(item)}
                        src={DarkCloseButton}
                        alt='Single Handle'
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <ul className='outer-ul'>
                {menu &&
                  menu.length &&
                  filterNotHiddenItem(menu).length &&
                  getFilterNothiddenitemWithProduct({
                    menu,
                    handleSetActive,
                    setFirstCategoryActive,
                    hasSubcategory,
                    getMenusSubcategory,
                  })}
              </ul>
            )}
            {/* </Col> */}
          </CustomStyledCol>
        )}
        <Col md='9' className={`plp-right-nav plp-right-nav-in`}>
          <Col sm={12} className='plp-filters'>
            <div data-testid='menu-search-testid' className='search-menu'>
              <InputBox
                name='searchInput'
                className='search-menu-input'
                onKeyPress={e => handleKeyPress(e)}
                onChange={e => handleInput(e)}
                value={inputSearchValue}
                placeholder={translateWithI18Next(SEARCHOURMENU)}
                data-testid='search-our-menu'
                aria-label='Search our menu'
                onFocus={e => (e.target.placeholder = '')}
                onBlur={e => (e.target.placeholder = `${translateWithI18Next(SEARCHOURMENU)}`)}
              />
              <span className='search-icon'>
                <ImageComponent srcFile={SearchIcon} className='search-icon-img' />
              </span>
              {(inputSearchValue.length > 2 && !searchMode.isSearchedMode) ||
              (inputSearchValue.length > 2 && searchMode.isSearchedMode && visibleHiddenProductsCount >= 0) ? (
                <img
                  className='input-dark-cross'
                  data-testid='clear-all-input'
                  onClick={() => clearSearch()}
                  src={DarkCloseButton}
                  alt='Close Button'
                />
              ) : null}
              {inputSearchOpen && (
                <div ref={filterRef} className='inputAutoCompletePLP'>
                  {suggestedData?.length > 0 && (
                    <div>
                      <div className='SuggestionHeader'>Suggested Search Terms</div>
                      <ul className='autoCompleteListPLP'>
                        {suggestedData.map((item, index) => (
                          <li
                            onClick={() => filteredData(item)}
                            key={item.mdmId + index}
                            data-testid={`suggestion-click-${item.name}`}
                            className='wrapperAutoCompletePLP'
                          >
                            <span className='searchgrey-icon-img'>
                              <ImageComponent srcFile={SearchIconGrey} />
                            </span>
                            <span>{item.dname?.[0]?.value}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Col>
          {searchMode.isSearchedMode && visibleHiddenProductsCount > 0 && (
            <Row className='pt-5'>
              <h2 className='found-text'>
                {translateWithI18Next(WE_FOUND_TEXT)} {visibleHiddenProductsCount}
                {` "${searchMode.searchedData.toUpperCase()}"`}
              </h2>
            </Row>
          )}
          {[...filterList, ...dietaryList].length > 0 && visibleHiddenProductsCount === 0 ? (
            <Row className='pt-5 no-data-found-plp'>
              <h2 className='found-text'>
                {translateWithI18Next(WE_FOUND_TEXT)} {visibleHiddenProductsCount} '
                {translateWithI18Next(RESULTS.toUpperCase())}'
              </h2>
            </Row>
          ) : (
            [...filterList, ...dietaryList].length > 0 &&
            visibleHiddenProductsCount > 0 && (
              <Row className={`pt-5 ${getClassName(dietaryList)}`}>
                <h2 className='found-text'>
                  {WE_FOUND_TEXT} {visibleHiddenProductsCount} '{translateWithI18Next(RESULTS.toUpperCase())}'
                </h2>
              </Row>
            )
          )}
          <Row
            className={
              searchMode.isSearchedMode || filterList.length > 0 || dietaryList.length > 0 ? '' : 'plp-sections'
            }
          >
            <Col>
              {!searchMode.isSearchedMode && categories && categories.length
                ? categoriesMenu(categories, renderItemList)
                : OnSerchElmnt({
                    searchMode,
                    filterList,
                    dietaryList,
                    products,
                    viewUp: false,
                    tenantData,
                    getCardCount: null,
                    catalogs,
                    storeClosedData,
                    setShowTopScrollBtn,
                    searchModeElmnt,
                    MenuItemList,
                    CATEGORY_ID,
                  })}
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

function displaySectionWhenThereAreNoMatchingProduct(
  paramValue,
  dispositionNew,
  dispositionType,
  categoryStatus,
  storeClosedData,
  handleClose,
) {
  const PRODUCT_NOT_FOUND_CONSTANTS = {
    CLEAR_ALL_MSG: {
      MSGTXT1: 'categoryNotAvailable',
      MSGTXT2: 'notAvailable',
      MSGTXT3: getTernaryValue(dispositionType.type, ` for ${dispositionType}`, ''), // exploring our menu option.',
    },
    CONTINUE: 'continue',
  };

  return (
    /* Modal for error message when incorrect url for deeplink */
    getAndCheck(categoryStatus, !storeClosedData?.isStoreClosed) && (
      <CartAlertFormInsideModel
        handleClose={handleClose}
        classNames='clear-cart-modal'
        CartAlertForm={
          <CartAlertForm
            splitTitle={PRODUCT_NOT_FOUND_CONSTANTS.CLEAR_ALL_MSG}
            imageSrc={CartError}
            altText={'cart-error'}
            confirmButtonText={translateWithI18Next(PRODUCT_NOT_FOUND_CONSTANTS?.CONTINUE)}
            confirmHandler={handleClose}
          />
        }
      />
    )
  );
}
function localizedClass(localized) {
  return `plp-left-nav${localized ? ' localized' : ''}`;
}
